import { Component, OnInit } from '@angular/core';
import {
  ContactUsData,
  defaultContactUsData,
} from '../../../../shared/models/registration';
import { RegistrationService } from '../../../../shared/services/user/registration.service';
import { NotificationService } from '../../../../shared/services/notification.service';
import { Router } from '@angular/router';

@Component({
  selector: 'app-medshorts-contact',
  templateUrl: './contact.component.html',
  styleUrls: ['./contact.component.scss'],
})
export class MedshortsContactComponent implements OnInit {
  contactData: ContactUsData = defaultContactUsData;
  hasMessage = false;
  isUrlTestimonial = false;
  buttonNextOptions: any = {
    text: 'Submit',
    type: 'default',
    width: 150,
    useSubmitBehavior: true,
  };

  phoneRules: any = { X: /[02-9]/ };
  role: string;

  constructor(
    private registrationService: RegistrationService,
    private router: Router,
    private notificationService: NotificationService,
  ) {}

  ngOnInit() {}

  onSubmit(e) {
    this.registrationService.preRegistration(this.contactData).subscribe(
      () => {
        this.hasMessage = true;
        this.notificationService.showNotify(
          'You have successfully sent the message to Medshorts!',
          'success',
          5000,
        );
      },
      () => {
        this.notificationService.showNotify(
          'Someone went wrong',
          'error',
          3000,
        );
      },
    );
    e.preventDefault();
  }
}
